export default __webpack_public_path__ + "static/media/app-sidebar-logo.a7dc9e52.png";